module.exports = __webpack_public_path__ + "img/Flutter-min.bf2aaf04.webp";